import { Component } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { filter, map } from 'rxjs/operators';
import { LoadingService } from '../loading.service';
import { isNullOrUndefined } from 'util';

@Component({
    selector: 'cmn-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss'],
    animations: [
        trigger('inOut', [
            state('true', style({
                opacity: 1
            })),
            state('false', style({
                opacity: 0,
                display: 'none'
            })),
            transition('true => false', animate('320ms ease-in-out')),
            transition('false => true', animate('320ms ease-in-out'))
        ])
    ]
})
export class LayoutComponent {

    private subscriptions: Subscription = new Subscription();
    public outlet = 'primary';
    constructor(
        public loadingService: LoadingService,
        private router: Router,
        private activatedRoute: ActivatedRoute
    ) {
        this.subscriptions.add(
            this.router.events
                .pipe(
                    filter(event => {
                        return event instanceof NavigationEnd;
                    })
                )
                .pipe(
                    map(() => this.outlet = this.preparePageTitle(this.activatedRoute.root))
                )
                .subscribe()
        );
    }

    private preparePageTitle(route: ActivatedRoute) {
        if (route.firstChild) {
            return this.preparePageTitle(route.firstChild);
        } else {
            let outlet = 'primary';
            if (!isNullOrUndefined(route.routeConfig) && !isNullOrUndefined(route.routeConfig.outlet)) {
                outlet = route.routeConfig.outlet;
            }
            return outlet;
        }
    }

}
